var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ct-aside-control ct-aside-control-light ct-aside-data",
      class: [
        _vm.modalPositionClass,
        _vm.modalSizeClass,
        { "ct-aside-control-slide-open": _vm.show },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "ct-aside-control-actions" },
        [
          _vm._t("modal-header-actions"),
          _vm._v(" "),
          _vm.closeBtn
            ? _c(
                "button",
                {
                  staticClass: "close position-absolute pos-top pos-right",
                  attrs: {
                    type: "button",
                    title: "Fechar",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [
                  _c("span", [
                    _c(
                      "svg",
                      {
                        staticClass: "svg-inline--fa fa-times fa-w-13",
                        attrs: {
                          focusable: "false",
                          "data-prefix": "fas",
                          "data-icon": "times",
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 320 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "transition-fade" } }, [
        _vm.showContent
          ? _c("div", { staticClass: "ct-aside-control-content" }, [
              _c(
                "div",
                {
                  class: [
                    { "d-flex flex-column flex-fill": _vm.fullHeight },
                    _vm.classContent,
                  ],
                },
                [_vm._t("content", null, { title: _vm.modalTitle })],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }